import React from 'react'
import { FormModal } from '@ztechapps/webui.form'
import { TemplateFormContent } from '../TemplateFormContent'
import { EditContextMenuItem } from '../EditContextMenuItem'
import { useTemplateContext } from '../Context'
import { useManageTemplate } from '@ztechapps/common.hook'

export const EditTemplateFormModal = ({ template }) => {
  const { category, parentOnFilter } = useTemplateContext()
  const { validate, onUpdateSubmit, onApply } = useManageTemplate({ category, onFilter: parentOnFilter })

  return (
    <FormModal
      {...{
        trigger: EditContextMenuItem,
        initialValues: template,
        validate,
        onSubmit: onUpdateSubmit,
        title: 'Edit template',
        saveText: 'Save',
        onApply,
      }}
    >
      <TemplateFormContent />
    </FormModal>
  )
}
